import { Image, Container, Row, Col } from 'react-bootstrap';
import Img from '../Img/Services/rug-services-banner.jpg';

// import S1 from "../Img/Services/Sourcing.jpg"
import S1 from "../Img/Services/Home-main-1.jpg"
// import S2 from "../Img/Services/Curation.jpg"
import S3 from "../Img/Services/PRODUCT DEVLOPMENT IMAGE.png"
import S4 from "../Img/Services/Vender Negotiation.jpeg"
import S5 from "../Img/Services/Custom.jpeg"
// import S6 from "../Img/Services/Quality Control-Carpet.jpg"
import S6 from "../Img/Rugs/QUALITY CHECK 3.jpg"
// import S7 from "../Img/Services/Ship-Rug.jpg"
import S7 from "../Img/Services/Shipping 3.jpeg"
import S8 from "../Img/Services/Travel Planning.jpg"
import S9 from "../Img/Services/socialservice.jpg"
import "./Services.css"

function Services() {
    return (
        <>
            <Image className="fade-in responsive-img" src={Img} height={500} width="100%" fluid />
            <Container>
                <Row>
                    <Col>
                        <h1 className='text-center my-4 text-decoration-underline'><strong>Our Services</strong></h1>
                        <p className='text-center' style={{ fontSize: '20px' }}>We want our clients to make the best buying decisions and we
                            work closely with them to design, develop and source more effectively for their business. The various services
                            that we provide are enumerated below </p>
                    </Col>
                </Row>
            </Container>

            <Container>
                <Row className="d-flex justify-content-center">
                    <Col md={6} className="p-5 justify-text">
                        <h1 className="mb-4" style={{ paddingLeft: "2rem" }}>SOURCING</h1>
                        <ul>
                            {/* <li style={{ fontSize: '20px' }}>We deal with over 200 manufacturing companies across the Indian sub-continent</li>
                            <li style={{ fontSize: '20px' }}> Help our clients align with the right category of vendor on the basis of product specifications and volume</li>
                            <li style={{ fontSize: '20px' }}> We go behind the scenes from what vendors present at Trade Fairs - to know the actual scale of their operations and their on-ground performance</li> */}
                            <li style={{ fontSize: '20px' }} className='justify-text'>Sourcing and Procurement are not just words and profiles; it’s an elusive art that comes with the passage of time spent in the trade. </li>
                            <li style={{ fontSize: '20px' }} className='justify-text'>We have created a supply chain network that connects diverse manufacturers from India.</li>
                            <li style={{ fontSize: '20px' }} className='justify-text'>We work closely with clients to curate products, which items are working well in their market, and what new trends are coming in, and we curate the buying itinerary and selection of vendors accordingly.</li>
                            <li style={{ fontSize: '20px' }} className='justify-text'>Help our clients align with the right category of vendor based on product specifications and volume.</li>
                            {/* <li style={{ fontSize: '20px' }} className='justify-text'>Help our clients align with the right category of vendor based on product specifications and volume.</li> */}
                            {/* <li style={{ fontSize: '20px' }} className='justify-text'>We go behind the scenes from what vendors present at Trade Fairs - to know the actual scale of their operations and their on-ground performance</li> */}
                            {/* <li style={{ fontSize: '20px' }} className='justify-text'>Our mission is to bring everything you need under one roof, ensuring that every product we source meets stringent international legal, social, and environmental standards.</li> */}
                            {/* <li style={{ fontSize: '20px' }} className='justify-text'>Our knowledge and expertise will empower you to make better-informed sourcing decisions in India. </li> */}
                            {/* <li style={{ fontSize: '20px' }} className='justify-text'>Please proceed with all the above points on the sourcing line.</li> */}
                        </ul>
                    </Col>
                    <Col md={6} className="p-5 justify-text">
                        <Image src={S1} alt="SOURCING" height={450} width="100%" />
                    </Col>
                </Row>
            </Container>

            <Container>
                <Row className="d-flex justify-content-center">
                    <Col md={6} className="p-5 justify-text">
                        <Image src={S1} alt="CURATION" width="100%" />
                    </Col>
                    <Col md={6} className="p-5 justify-text">
                        {/* <h1 className="mb-4" style={{ paddingLeft: "2rem" }}>CURATION</h1> */}
                        <ul>
                            {/* <li style={{ fontSize: '20px' }}>We work closely with clients to curate products that are tailored to meet the aesthetics and price point requirements for their markets</li> */}
                            {/* <li style={{ fontSize: '20px' }}>We study our clients’ sales reports to analyse what items are working well in their market, and what new trends are coming in, and we curate the buying itinerary and selection of vendors accordingly</li> */}
                            <li style={{ fontSize: '20px' }}>We go behind the scenes from what vendors present at Trade Fairs - to know the actual scale of their operations and their on-ground performance. </li>
                            <li style={{ fontSize: '20px' }}> Our mission is to bring everything you need under one roof, ensuring that every product we source meets stringent international legal, social, and environmental standards.</li>
                            <li style={{ fontSize: '20px' }}> Our knowledge and expertise will empower you to make better-informed sourcing decisions in India.</li>
                            {/* <li style={{ fontSize: '20px' }}> Please proceed with all the above points on the sourcing line.</li> */}
                        </ul>
                    </Col>
                </Row>
            </Container>

            <Container>
                <Row className="d-flex justify-content-center">
                    <Col md={6} className="p-5 justify-text">
                        <h1 className="mb-4" style={{ paddingLeft: "2rem" }}>PRODUCT DEVELOPMENT</h1>
                        <ul>
                            {/* <li style={{ fontSize: '20px' }}>Strong technical understanding allows us to work closely with vendors on new product developments</li>
                            <li style={{ fontSize: '20px' }}>We can develop private label collections for our clients</li> */}
                            <li style={{ fontSize: '20px' }}>We work closely with vendors on new product developments and help you create an exclusive range tailored to your brand.</li>
                            <li style={{ fontSize: '20px' }}>Our process begins with a collaborative meeting to identify your needs, followed by the development of detailed specifications and visuals. </li>
                            <li style={{ fontSize: '20px' }}>We ensure a seamless prototyping phase with direct communication between you and our manufacturers for precise adjustments. </li>
                            <li style={{ fontSize: '20px' }}>Once the prototypes are validated, we launch production to bring your vision to life. With ongoing market trend analysis and dedicated support from our team.</li>
                        </ul>
                    </Col>
                    <Col md={6} className="p-5 justify-text">
                        <Image src={S3} alt="PRODUCT DEVELOPMENT" width="100%" height={450} />
                    </Col>
                </Row>
            </Container>

            <Container>
                <Row className="d-flex justify-content-center">
                    <Col md={6} className="p-5 justify-text">
                        <Image src={S4} alt="VENDOR NEGOTIATIONS" width="100%" />
                    </Col>
                    <Col md={6} className="p-5 justify-text">
                        <h1 className="mb-4" style={{ paddingLeft: "2rem" }}>VENDOR NEGOTIATIONS</h1>
                        <ul>
                            {/* <li style={{ fontSize: '20px' }}>Clients benefit from low prices already negotiated by us</li>
                            <li style={{ fontSize: '20px' }}>Strong product and market knowledge allows us to get the best rates from the vendors</li>
                            <li style={{ fontSize: '20px' }}>We help our clients negotiate favourable payment terms</li> */}
                            <li style={{ fontSize: '20px' }}>We have family roots working with a product sourcing agency that better knows the market, Knowledge and vendor factories, we ensure the factory has the right skills to make what you need.</li>
                            <li style={{ fontSize: '20px' }}>Clients benefit- Negotiate the best prices from Vendors.</li>
                            <li style={{ fontSize: '20px' }}>We help our clients negotiate favourable payment terms.</li>
                        </ul>
                    </Col>
                </Row>
            </Container>

            <Container>
                <Row className="d-flex justify-content-center">
                    <Col md={6} className="p-5">
                        <h1 className="mb-4" style={{ paddingLeft: "2rem" }}>CUSTOM AND BESPOKE RUGS</h1>
                        <ul>
                            <li style={{ fontSize: '20px' }} className='justify-text'>Our agency can provide custom made rug solutions to meet our clients' specific needs.</li>
                            <li style={{ fontSize: '20px' }} className='justify-text'>This includes sourcing products based on exact size and shapes, Design and colours match from buyer specification, row materials used in rugs and quality specification.</li>
                            <li style={{ fontSize: '20px' }} className='justify-text'>We carefully study the packing of our sourcing products to guarantee their delivery in perfect condition, always on time and in the place client need.</li>
                            <li style={{ fontSize: '20px' }} className='justify-text'>This ensures our clients get exact products at affordable prices compared to if they sourced them on their own.</li>
                        </ul>
                    </Col>
                    <Col md={6} className="p-5 justify-text">
                        <Image src={S5} alt="Window Solution" width="100%" />
                    </Col>
                </Row>
            </Container>

            <Container>
                <Row className="d-flex justify-content-center">
                    <Col md={6} className="p-5">
                        <Image src={S6} alt="Quality" width="100%" />
                    </Col>
                    <Col md={6} className="p-5">
                        <h1 className="mb-4" style={{paddingLeft: "2rem" }}> PRODUCTION & QUALITY CONTROL </h1>
                        <ul className='justify-text'>
                            <li style={{ fontSize: '20px' }} className='justify-text'>We have a Quality Control Team full-time in the field at various production hubs.</li>
                            <li style={{ fontSize: '20px' }} className='justify-text'>Our Network staff rotate between production sites on the ground and these terms closely monitor the production process and provide you firsthand,  work-in-progress report and updates.</li>
                            {/* <li style={{ fontSize: '20px' }} className='justify-text'>We have a rigorous quality control process in place to ensure that the products we source are up to our clients' standards. This process includes factory inspections, product testing, and quality assurance protocols.</li> */}
                            <li style={{ fontSize: '20px' }} className='justify-text'>Our proactive approach helps identify and resolve any defects/issues before shipping.</li>

                        </ul>
                    </Col>
                </Row>
            </Container>

            <Container>
                <Row className="d-flex justify-content-center">
                    <Col md={6} className="p-5">
                        <h1 className="mb-4" style={{ paddingLeft: "2rem" }}>SHIPPING AND LOGISTICS</h1>
                        <ul>
                            {/* <li style={{ fontSize: '20px' }}>Our office will assist with all shipping and logistics planning from the factory to our client’s warehouse</li>
                            <li style={{ fontSize: '20px' }}>We work with multiple forwarders to get the best rates</li>
                            <li style={{ fontSize: '20px' }}>We guide new clients on import logistics issues and help train their teams</li> */}
                            <li className='justify-text' style={{ fontSize: '20px' }}>We have established strategic partnerships with established shipping agents and courier companies across all major manufacturing centers to ensure prompt and reliable delivery of your shipments. Our dedicated shipping team meticulously monitors each order after it leaves from the factories to ensure it meets the shipping schedule.</li>
                            <li className='justify-text' style={{ fontSize: '20px' }}>We keep you informed with real-time updates on your goods’ movement, empowering you to make well-informed decisions. Additionally, our team collaborates with both customers and forwarders to develop strategic consolidation plans, effectively reducing shipping costs and optimizing your logistics.</li>
                        </ul>
                    </Col>
                    <Col md={6} className="p-5 justify-text">
                        <Image src={S7} alt="Shipping" width="100%" height={550} />
                    </Col>
                </Row>
            </Container>

            <Container>
                <Row className="d-flex justify-content-center">
                    <Col md={6} className="p-5 justify-text">
                        <Image src={S8} alt="Travel" width="100%" />
                    </Col>
                    <Col md={6} className="p-5">
                        <h1 className="mb-4" style={{ paddingLeft: "2rem" }}>TRAVEL PLANNING</h1>
                        <ul className='justify-text'>
                            <li style={{ fontSize: '20px' }}>Customized itinerary developed for each client for their buying visit</li>
                            <li style={{ fontSize: '20px' }}>We take care of all travel arrangements, so our clients can focus their energy on sourcing</li>
                        </ul>
                    </Col>
                </Row>
            </Container>

            <Container>
                <Row className="d-flex justify-content-center">
                    <Col md={6} className="p-5">
                        <h1 className="mb-4" style={{ paddingLeft: "2rem" }}>SOCIAL SERVICES</h1>
                        <ul>
                            <li className='justify-text' style={{ fontSize: '20px' }}>Every year, we donate at least 2% of our profits to support social services for needy peoples.</li>
                        </ul>
                    </Col>
                    <Col md={6} className="p-5 justify-text">
                        <Image src={S9} alt="Shipping" width="100%" height={300} />
                    </Col>
                </Row>
            </Container>
        </>
    )
}

export default Services